import { useService } from '@visiba/instantiation';
import { AnalyticService } from '@application/analytic/analytic.service';
import { VisibaLink } from '@components/visiba-link.component';
import { useAnalyticContext } from './analytic_link.provider';
import { Link, LinkProps } from 'react-router-dom';
import type { ReactNode } from 'react';

interface Props extends LinkProps {
	action: string;
	to: string;
	children: ReactNode;
	__TEMP__forceRegularLink?: boolean;
}

export function AnalyticLink({ to, action, children, __TEMP__forceRegularLink, ...rest }: Props): JSX.Element {
	const analytic = useService(AnalyticService);
	const category = useAnalyticContext();

	function handleClick(): void {
		analytic.trackEvent(category, action);
	}

	if (__TEMP__forceRegularLink) {
		return (
			<Link to={to} onClick={handleClick} {...rest}>
				{children}
			</Link>
		);
	}

	return (
		<VisibaLink to={to} __TEMP__to={to} onClick={handleClick} {...rest}>
			{children}
		</VisibaLink>
	);
}
